import { Injectable } from "@angular/core";
import { Model_Datasource, AbsPaginatedGrid } from 'src/app/app.models';
import { Guid } from 'guid-typescript';
import * as moment from 'moment';
import { DatasourceOfflineDao } from './datasource-offline.dao';

const TB_DATASOURCES_NAME = "LOCAL_TB_DATASOURCES";

@Injectable()
export class DatasourcesOfflineWebDao extends DatasourceOfflineDao {
    constructor() {
        super();
    }

    doSyncDatasourcesAction(_datasources: Model_Datasource[]): Promise<void> {
        return new Promise((resolve, reject) => {
            this.doClearDatasourcesAction();
            _datasources.forEach((datasource, index, datasources) => datasources[index].SYNCED = true);
            this.doInsertDatasourcesAction(_datasources).then(() => {
                resolve();
            }, err => reject(err));
        });
    }

    doClearDatasourcesAction() {
        return new Promise<void>((resolve, reject) => {
            localStorage.setItem(TB_DATASOURCES_NAME, "[]");
            resolve();
        })
    }

    doGetDatasourcesAction(): Promise<Model_Datasource[]> {
        return new Promise((resolve, reject) => {
            var datas: Model_Datasource[] = [];
            const storageDatas = localStorage.getItem(TB_DATASOURCES_NAME);
            if (!!storageDatas && storageDatas != 'undefined' && storageDatas != 'null') {
                try {
                    datas = JSON.parse(storageDatas);
                } catch(e) { console.log(e) }
            }
            resolve(datas);
        });
    }

    doInsertDatasourcesAction(_datasources: Model_Datasource[]): Promise<void> {
        return new Promise((resolve, reject) => {
            this.doGetDatasourcesAction().then((_datasTable: Model_Datasource[]) => {
                var newDatas = _datasTable.concat(_datasources);
                localStorage.setItem(TB_DATASOURCES_NAME, JSON.stringify(newDatas));
                resolve();
            }, err => reject(err));
        });
    }

    doSaveDatasourceAction(_datasource: Model_Datasource): Promise<Model_Datasource> {
        return new Promise((resolve, reject) => {
            this.doGetDatasourcesAction().then((_datasources: Model_Datasource[]) => {
                var newDatas = _datasources;
                var itemIndex = _datasources.findIndex(i => i.NUM_DATASOURCE == _datasource.NUM_DATASOURCE);
                if (itemIndex !== -1) {
                    newDatas[itemIndex].GUID_SYNCHRONISATION = Guid.create().toString();
                    newDatas[itemIndex].DATE_MODIFICATION = moment().format();
                    newDatas[itemIndex].SYNCED = _datasource.SYNCED;
                    newDatas[itemIndex].datas = _datasource.datas;
                }
                localStorage.setItem(TB_DATASOURCES_NAME, JSON.stringify(newDatas));
                resolve(newDatas[itemIndex]);
            }, err => reject(err));
        });
    }

    doGetDatasourceAction(_numDatasource: string): Promise<Model_Datasource> {
        return new Promise((resolve, reject) => {
            this.doGetDatasourcesAction().then((_datasTable: Model_Datasource[]) => {
                const datasource = _datasTable.find(w => w.NUM_DATASOURCE == _numDatasource);
                resolve(datasource);
            }, err => reject(err));
        });
    }

    doBuildDatasourceByNumAction(_num: string) {
        return new Promise<AbsPaginatedGrid<any>>(async (resolve, reject) => {
            const datasource = await this.doGetDatasourceAction(_num);
            const absGrid = !!datasource.datas ? datasource.datas : new AbsPaginatedGrid<any>();
            resolve(absGrid);
        })
    }
}
